import React, { useState, useRef, useCallback } from "react";
import EmojiPicker from "emoji-picker-react";
import { api } from "../api";

export default function InputArea({ onSend, onTypingStart, onTypingStop, disabled }) {
  const [text, setText]             = useState("");
  const [showEmoji, setShowEmoji]   = useState(false);
  const [uploading, setUploading]   = useState(false);
  const fileInputRef = useRef(null);
  const typingTimer  = useRef(null);

  function handleTextChange(e) {
    setText(e.target.value);
    onTypingStart();
    clearTimeout(typingTimer.current);
    typingTimer.current = setTimeout(onTypingStop, 1500);
  }

  function handleEmojiClick(emojiData) {
    setText((prev) => prev + emojiData.emoji);
    setShowEmoji(false);
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendText();
    }
  }

  function sendText() {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend({ messageType: "TEXT", content: trimmed });
    setText("");
    onTypingStop();
    clearTimeout(typingTimer.current);
  }

  const handleFileChange = useCallback(async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    setUploading(true);
    try {
      const result = await api.uploadFile(file);
      if (result.error) throw new Error(result.error);
      onSend({
        messageType: result.messageType,
        mediaUrl:    result.url,
        mediaName:   result.mediaName,
        mediaSize:   result.mediaSize,
        content:     text.trim() || null,
      });
      setText("");
    } catch (err) {
      alert("Errore upload: " + err.message);
    } finally {
      setUploading(false);
    }
  }, [onSend, text]);

  return (
    <div className="input-area">
      {/* Emoji picker overlay */}
      {showEmoji && (
        <div className="emoji-overlay">
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            theme="light"
            lazyLoadEmojis
            height={380}
          />
        </div>
      )}

      <button
        className="icon-btn emoji-btn"
        onClick={() => setShowEmoji((v) => !v)}
        title="Emoji"
        aria-label="Apri emoji picker"
      >
        😊
      </button>

      <textarea
        className="msg-input"
        placeholder="Scrivi un messaggio…"
        value={text}
        onChange={handleTextChange}
        onKeyDown={handleKeyDown}
        rows={1}
        disabled={disabled}
      />

      {/* Pulsante allega file */}
      <button
        className="icon-btn attach-btn"
        onClick={() => fileInputRef.current?.click()}
        title="Allega file"
        aria-label="Allega file"
        disabled={uploading || disabled}
      >
        {uploading ? "⏳" : "📎"}
      </button>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip"
        onChange={handleFileChange}
      />

      {/* Invia */}
      <button
        className="icon-btn send-btn"
        onClick={sendText}
        disabled={!text.trim() || disabled}
        title="Invia"
        aria-label="Invia messaggio"
      >
        ➤
      </button>
    </div>
  );
}
